import {useEffect, useRef, useState} from "react";
import {Link} from "react-router-dom";
import {Check, ShoppingCart} from "lucide-react";
import {CART_NOTIFY_EVENT} from "./useLandingCart";

// Single toast host for the landing page. Listens for cart notifications and
// shows a lightweight confirmation near the bottom of the viewport.
export default function CartToast() {
  const [message, setMessage] = useState(null);
  const timer = useRef(null);

  useEffect(() => {
    const handler = (event) => {
      setMessage(event.detail?.message || "Added to cart");
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => setMessage(null), 2600);
    };
    window.addEventListener(CART_NOTIFY_EVENT, handler);
    return () => {
      window.removeEventListener(CART_NOTIFY_EVENT, handler);
      if (timer.current) clearTimeout(timer.current);
    };
  }, []);

  if (!message) return null;

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed bottom-5 left-1/2 z-[100000001] flex max-w-[92vw] -translate-x-1/2 items-center gap-3 rounded-2xl border border-slate-200 bg-white px-4 py-3 shadow-[0_18px_40px_-12px_rgba(15,23,42,0.35)]"
      style={{animation: "fillop-pop 0.28s cubic-bezier(0.34, 1.56, 0.64, 1) both"}}
    >
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-emerald-50 text-emerald-600">
        <Check className="h-4 w-4" />
      </span>
      <div className="min-w-0">
        <p className="m-0 text-sm font-semibold text-slate-900">{message}</p>
        <Link
          to="/cart"
          className="inline-flex items-center gap-1 text-xs font-medium text-blue-700 no-underline hover:text-blue-900"
        >
          <ShoppingCart className="h-3 w-3" /> View cart
        </Link>
      </div>
    </div>
  );
}
